import { Routes, Route } from "react-router";
import LastReading from '../Pages/LastReading'
import Readings from '../Pages/Readings'
import Statistics from '../Pages/Statistics/Statistics'
import Patient from "../Pages/Patient/Patient";
import ShowMeasurementPage from "../Pages/UserPDF/ShowMeasurementPage";

export const AppRouter = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<Readings />} />
                <Route name="last-reading" path="/last-reading" element={<LastReading />} />
                <Route path="/statistics" element={<Statistics />} />
                <Route name="patient" path="/patient/:patientId" element={<Patient />} />

                {/* ShowMeasurement routes (unauthenticated) */}
                <Route path="/ShowMeasurement" element={<ShowMeasurementPage />} />
                <Route path="/ShowMeasurement/:measurementUUID" element={<ShowMeasurementPage />} />
            </Routes>
        </>
    )
}
